import React from "react";
import { BizFindPage } from "../../../Component/Products/biz";

const FindVerfication = () => <BizFindPage />;

export default FindVerfication;
